export default {
  hero_badge: 'Centre de connaissances et annuaire de ressources',
  hero_title: 'USFans Spreadsheet — trouvez, comparez et explorez les ressources',
  hero_subtitle:
    'Découvrez des ressources organisées du tableur USFans, des informations produits, la recherche de vendeurs, des guides de livraison, des avis, des comparaisons et des tutoriels pratiques — tout en un seul endroit pour rendre votre recherche plus rapide et plus simple.',
  hero_cta_primary: 'usfans spreadsheet',
  hero_cta_secondary: 'acheter maintenant',
  hero_hint: 'Parcourez les produits par catégorie ou continuez vers le site principal',

  trust_1_title: 'Ressources organisées',
  trust_1_desc: 'Trouvez des informations utiles dans un seul endroit structuré.',
  trust_2_title: 'Recherche plus rapide',
  trust_2_desc: 'Comparez produits, vendeurs et ressources sans perdre de temps.',
  trust_3_title: 'Guides à jour',
  trust_3_desc: 'Des guides pratiques sur les tableurs, la livraison et l’entrepôt.',
  trust_4_title: 'La sécurité d’abord',
  trust_4_desc: 'Apprenez à évaluer les liens, vendeurs et informations avant de décider.',

  category_section_title: 'Parcourez les produits par catégorie',
  category_section_subtitle:
    'Choisissez une catégorie pour explorer les produits associés directement sur le site principal.',
  category_dropdown_label: 'Choisissez une catégorie',
  category_dropdown_placeholder: 'Sélectionnez une catégorie…',
  category_viewAll: 'Voir toutes les catégories',

  what_title: 'Qu’est-ce qu’un tableur USFans ?',
  what_body:
    'Un tableur USFans est une façon structurée d’organiser et d’explorer les informations sur les produits, les vendeurs et les ressources. Au lieu de chercher dans des pages dispersées, vous pouvez utiliser des ressources organisées pour découvrir des informations, comparer des options et poursuivre votre recherche plus efficacement.',
  what_cta: 'Découvrez le guide du tableur USFans',

  guides_title: 'Guides populaires du tableur USFans',
  guides_subtitle:
    'Commencez par ces guides pratiques pour comprendre les tableurs, la recherche et les comparaisons.',
  guide_1_title: 'Qu’est-ce qu’un tableur USFans ?',
  guide_1_desc: 'Une introduction claire aux tableurs et à leur rôle dans l’organisation.',
  guide_2_title: 'Comment utiliser un tableur USFans',
  guide_2_desc: 'Des conseils pas à pas pour parcourir, comparer et organiser les ressources.',
  guide_3_title: 'Annuaire du tableur USFans',
  guide_3_desc: 'Un aperçu des principales zones de ressources et catégories.',
  guide_4_title: 'Guide des vendeurs USFans',
  guide_4_desc: 'Ce qu’il faut vérifier avant de faire confiance à un vendeur ou à un lien produit.',
  guide_5_title: 'Recherche de produits USFans',
  guide_5_desc: 'Comment comparer produits et catégories efficacement.',
  guide_6_title: 'Guide des frais de livraison USFans',
  guide_6_desc: 'Comprenez ce qui peut influencer les frais et les modes de livraison.',
  guides_viewAll: 'Voir tous les guides',

  // Articles piliers
  pillar_title: 'Articles piliers USFans Spreadsheet',
  pillar_subtitle:
    'Explorez notre bibliothèque complète de guides détaillés sur les tableurs, produits, vendeurs, livraison, coupons, entrepôt, avis et sécurité.',

  info_review_title: 'Avis sur USFans',
  info_review_desc:
    'Découvrez un aperçu indépendant de USFans : fonctionnalités, utilisabilité, avantages potentiels et points importants.',
  info_shipping_title: 'Frais de livraison USFans',
  info_shipping_desc:
    'Découvrez ce qui influence les frais de livraison : mode, poids du colis, destination et autres variables.',
  info_legit_title: 'USFans est-il fiable ?',
  info_legit_desc:
    'Comprenez ce que vous devez vérifier avant d’utiliser une plateforme, un vendeur, un lien ou un service.',
  info_cta: 'Découvrez les guides USFans',

  compare_title: 'Comparez avant de décider',
  compare_subtitle: 'Utilisez ces critères pour réfléchir à ce qui compte le plus pour votre recherche.',
  compare_col_feature: 'Fonctionnalité',
  compare_col_spreadsheet: 'Recherche en tableur',
  compare_col_seller: 'Recherche de vendeur',
  compare_r1_label: 'Profondeur d’information',
  compare_r1_a: 'Élevée',
  compare_r1_b: 'Moyenne',
  compare_r2_label: 'Facilité d’utilisation',
  compare_r2_a: 'Facile',
  compare_r2_b: 'Modérée',
  compare_r3_label: 'Idéal pour',
  compare_r3_a: 'Une recherche détaillée',
  compare_r3_b: 'Vérifier les vendeurs',

  safety_title: 'Centre de sécurité USFans',
  safety_body:
    'Avant d’utiliser un tableur, un lien produit ou une information vendeur, prenez le temps de vérifier la source et de comprendre les risques. Notre Centre de sécurité fournit des conseils pratiques pour vérifier les liens, les vendeurs, les informations produits et les risques liés au paiement.',
  safety_cta: 'Visitez le Centre de sécurité',

  faq_title: 'Questions fréquentes',
  faq_subtitle: 'Des réponses rapides aux questions les plus courantes sur le tableur USFans.',
  faq_q1: 'Qu’est-ce qu’un tableur USFans ?',
  faq_a1:
    'Un tableur USFans est une façon structurée d’organiser et d’explorer les informations sur les produits, les vendeurs et les ressources.',
  faq_q2: 'Comment utiliser un tableur USFans ?',
  faq_a2:
    'Commencez par choisir une catégorie ou un guide, comparez les ressources et suivez les liens vers le site principal quand vous êtes prêt.',
  faq_q3: 'USFans est-il fiable ?',
  faq_a3:
    'Vérifiez toujours de façon indépendante les vendeurs, les liens et les détails des produits avant toute décision ou achat.',
  faq_q4: 'Combien coûte la livraison USFans ?',
  faq_a4:
    'Les frais dépendent du mode, du poids du colis et de la destination. Consultez le site principal pour les détails actuels.',
  faq_q5: 'Où trouver des coupons USFans ?',
  faq_a5:
    'Les offres changent souvent, alors consultez directement le site principal pour les promotions en cours.',
  faq_q6: 'Qu’est-ce que l’entrepôt USFans ?',
  faq_a6:
    'L’entrepôt concerne le stockage et l’expédition des produits. Vérifiez les dernières informations sur le site principal.',
  faq_q7: 'Comment vérifier un vendeur USFans ?',
  faq_a7:
    'Examinez les détails des produits, comparez les options et vérifiez les informations de façon indépendante avant de faire confiance à un vendeur.',

  final_title: 'Prêt à explorer les ressources du tableur USFans ?',
  final_body:
    'Commencez par nos guides, comparaisons et ressources organisés du tableur USFans, puis continuez vers le site principal quand vous êtes prêt à aller plus loin.',
  final_cta_primary: 'Explorez le tableur USFans',
  final_cta_secondary: 'Visitez le site principal',

  footer_tagline:
    'Une ressource d’information indépendante sur les guides, catégories, avis et recherches du tableur USFans.',
  footer_resources: 'Ressources',
  footer_company: 'Entreprise',
  footer_legal: 'Mentions légales',
  footer_guides: 'Guides',
  footer_reviews: 'Avis',
  footer_shipping: 'Livraison',
  footer_safety: 'Sécurité',
  footer_faq: 'FAQ',
  footer_about: 'À propos',
  footer_editorial: 'Politique éditoriale',
  footer_contact: 'Contact',
  footer_privacy: 'Politique de confidentialité',
  footer_terms: 'Conditions',
  footer_disclaimer: 'Avertissement',
  footer_languages: 'Langues',
  footer_copyright: 'USFansLink.boats — ressource d’information indépendante. Tous droits réservés.',
  footer_disclaimer_text:
    'USFansLink.boats est une ressource d’information indépendante et n’est pas le site officiel USFans. Vérifiez toujours de façon indépendante les vendeurs, liens, produits, prix, informations de livraison et détails de transaction.',

  category_shoes: 'Chaussures',
  category_hoodies: 'Sweats / Pulls',
  category_tshirts: 'T-shirts',
  category_jackets: 'Vestes',
  category_pants: 'Pantalons / Shorts',
  category_headwear: 'Couvre-chefs',
  category_sets: 'Ensembles',
  category_underwear: 'Sous-vêtements',
  category_jersey: 'Maillot',
  category_accessories: 'Accessoires',
  category_bags: 'Sacs',
  category_belts: 'Ceintures',
  category_perfumes: 'Parfums',
  category_other: 'Autres articles',
};